import { createContext, useEffect, useState } from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { LandingView } from './views/LandingView.jsx'
import { SplitScreenTemplate } from './views/SplitScreenTemplate.jsx'
import { MenuView } from './views/MenuView.jsx'
import { ExperienceView } from './views/ExperienceView.jsx'
import { TechView } from './views/TechView.jsx'
import { AllProjectsView } from './views/AllProjectsView.jsx'
import { ProjectView } from './views/ProjectView.jsx'

const router = createBrowserRouter([
  { path: '/', element: <LandingView /> },
  {
    path: 'index',
    element: <SplitScreenTemplate />,
    children: [
      { index: true, element: <MenuView /> },
      { path: 'experience', element: <ExperienceView /> },
      { path: 'tech', element: <TechView /> },
      {
        path: 'projects',
        children: [
          { index: true, element: <AllProjectsView /> },
          { path: ':slug', element: <ProjectView /> }
        ]
      }
    ]
  }
])

const MAX_MOBILE_WIDTH = 1024

export const AppContext = createContext(null)

export const App = () => {
  const [store, setStore] = useState({
    isDesktopView: window.innerWidth > MAX_MOBILE_WIDTH
  })

  const el = document.getElementById('root')

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() =>
      setStore({
        ...store,
        isDesktopView: window.innerWidth > MAX_MOBILE_WIDTH
      })
    )
    resizeObserver.observe(el)

    return () => resizeObserver.unobserve(el)
    // eslint-disable-next-line
  }, [])

  return (
    <AppContext.Provider value={store}>
      <RouterProvider router={router} />
    </AppContext.Provider>
  )
}
